import { BaseQuery } from './BaseQuery';
import { IExecutionOptions } from '../models/query';
import { Query } from './Query';

export class GlobalQuery extends BaseQuery {
	getRawValue<T = any>(executionOptions: IExecutionOptions, callStackLevel: number = 1): T {
		const { key } = this.options;
		const context = Query.getContext(executionOptions, this.options);
		if (key && context) {
			const { globalQueries } = context;
			if (globalQueries && Array.isArray(globalQueries)) {
				const globalQuery = globalQueries.find(globalQuery => globalQuery.queryId === key);
				if (globalQuery) {
					const query = new Query(globalQuery, this.translationHelper, callStackLevel + 1);
					return query.execute(executionOptions);
				}
			}
		}
		return;
	}
}